import { useState } from 'react'
import { Typography, Box } from '@material-ui/core'
import { Checkbox, FormControlLabel, } from '@material-ui/core'

// Define CheckProps interface
interface CheckProps {
  item: any
  key: number
  dataShareTo: any
  setDataShareTo: any
}

/**
 * Custom `CheckBoxs` component declaration.
 * This component is used to select the email and give editing permissions with whom the document will be shared.
 * @param item
 * @param dataShareTo
 * @param setDataShareTo
 * @return CheckBoxs
 */
const CheckBoxs = ({ item, dataShareTo, setDataShareTo }: CheckProps): JSX.Element => {
  const [disabledCheckBox, setDisabledCheckBox] = useState(true);

  /**
   * This method is used to select the email to whom the document will be shared.
   * @param {Array} data 
   * @param {Boolean} bool
   * @return {void}
  */
  const handleCheckedShare = (data: any[], bool: boolean) => {
    setDisabledCheckBox(previousState => !previousState)
    const currentPeople = [...dataShareTo]
    if(currentPeople.length === 0 && bool)
    {
      currentPeople.push(data)
    }
    else if(currentPeople.length > 0)
    {
      if(!currentPeople.includes(data))
      {
        currentPeople.push(data)
      }
      else if(currentPeople.includes(data))
      {
        const val = currentPeople.indexOf(data)
        if(val > -1)
        {
          currentPeople.splice(val, 1)
        }
      }        
    }
    setDataShareTo(currentPeople)
  }

  /**
   * This method is used to give editing permissions to whom the document will be shared.
   * @param {Array} data 
   * @param {Boolean} bool
   * @return {void}
   */
  const handleCheckedEdit = (data: any[], bool: boolean) => {    
    const currentPeople = [...dataShareTo]
    const val = currentPeople.indexOf(data)      
    if(!bool)
    { 
      currentPeople[val][2] = false
    }
    else if(bool)
    {   
      currentPeople[val][2] = true
    } 
    setDataShareTo(currentPeople)
  }

  return (
    <div>
      <Box style={{display: 'flex', justifyContent: 'space-between' }}>
        <Box style={{ marginLeft:'2vh' }}>
          <Typography variant="subtitle1" align='center' style={{ marginRight:'1.8vh', marginTop:'1.1vh' }}>
            {item[0]}
          </Typography>
        </Box> 
        <Box style={{display: 'flex', justifyContent: 'space-between', marginRight:'4.6vh' }}>
          <FormControlLabel 
            value="" 
            label=""               
            control={
            <Checkbox
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleCheckedShare(item, event.target.checked)
              }}
              color={'primary'}/> 
            }
          />      
          <FormControlLabel
            value=""
            label=""
            style={{ marginLeft:'7.9vh' }}
            control={
              <Checkbox
                id={item[0]}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleCheckedEdit(item, event.target.checked)
                }}
                disabled={disabledCheckBox}
                color={'primary'}/> 
              }
          />      
        </Box>                  
      </Box>
    </div>
  )
}

export default CheckBoxs